Vue.component('ack-article-card-home', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-article-card-home',

	props: {
		article: {
			type: [Object, Array],
			required: true,
		},
	},
	computed: {
		//...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
	},
	data() {
		return {};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns'])
	},
	beforeDestroy() {},
	watch: {
		isMobile: {
			handler() {},
			deep: false,
		},
	},
});
